import $ from 'jquery';
import { initFilterTags } from './filter';
import pubSub from './pubSub';
import initPagination from './pagination';
import spinnerUtils from './spinner';

/**
 * @param  {HTMLElement} scope = document
 * @return {void}
 */
export default function initArticleListOrder() {
  $('.category-quantity select').on('change', (event) => {
    const element = $(event.currentTarget);
    const url = $(element).val();
    const token = spinnerUtils.create();

    // send with 'partial' param to get the content for ajax injection into the DOM
    $.get(url, { partial: '1' }, (data) => {
      if (data.length > 0) {
        const container = $(element).closest('.load-more-content');
        $(container).html(data);

        initFilterTags(document.querySelector('.delete-option'));
        initPagination(container);
        initArticleListOrder(container);

        pubSub.publish('reloaded.content', {
          scope: container[0],
        });
      }

      // destroy spinner
      spinnerUtils.destroy(token);
    });

    return false;
  });
}



// WEBPACK FOOTER //
// ./assets/js/components/article-list-order.js